import { render } from "./modalCoinPurchase.vue?vue&type=template&id=2b3e8669&scoped=true"
import script from "./modalCoinPurchase.vue?vue&type=script&lang=js"
export * from "./modalCoinPurchase.vue?vue&type=script&lang=js"

import "./modalCoinPurchase.vue?vue&type=style&index=0&id=2b3e8669&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3e8669"]])

export default __exports__